// src/components/SvgIcon/icons/receiptCheck.tsx
const ReceiptCheckIcon = (
  <svg
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    aria-hidden="true"
  >
    <path d="M7 3h10a2 2 0 0 1 2 2v14l-3-2-3 2-3-2-3 2V5a2 2 0 0 1 2-2z" />
    <path d="M9 11l2 2 4-4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
export default ReceiptCheckIcon;
